// extracted by mini-css-extract-plugin
export default {"monoSpaced":"global_monoSpaced__qRUO6"};